import { render } from "./modal-food-selection.vue?vue&type=template&id=ef6ead1a&scoped=true"
import script from "./modal-food-selection.vue?vue&type=script&lang=js"
export * from "./modal-food-selection.vue?vue&type=script&lang=js"

import "./modal-food-selection.vue?vue&type=style&index=0&id=ef6ead1a&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef6ead1a"],['__file',"src/components/login/modal-food-selection.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ef6ead1a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ef6ead1a', __exports__)) {
    api.reload('ef6ead1a', __exports__)
  }
  
  module.hot.accept("./modal-food-selection.vue?vue&type=template&id=ef6ead1a&scoped=true", () => {
    api.rerender('ef6ead1a', render)
  })

}


export default __exports__